"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../utils");

var DataDictionaryError_1 = require("./DataDictionaryError");

var ValidationLevel_1 = require("./ValidationLevel");

var ValueDesc =
/*#__PURE__*/
function () {
  function ValueDesc(description) {
    _classCallCheck(this, ValueDesc);

    this.description = description;
  }
  /**
   * Converts input material to required type.
   * @param input "something" to be converted to given property
   * @param  level (defaults to ValidationLevel.Basic)
   * @throws DataDictionaryError in case that input is not convertible or validation fails
   */


  _createClass(ValueDesc, [{
    key: "valueOf",
    value: function valueOf(input, level) {
      level = level || ValidationLevel_1.ValidationLevel.Basic;
      var res = this.validate(input, level);
      return res.get();
    }
    /**
     * Converts field of provided object to required type.
     * @param input object
     * @param  level validation level (defaults to ValidationLevel.Basic)
     * @param key name of field in input object. If `null`, value description object is used.
     * @throws DataDictionaryError in case that input is not convertible or validation fails
     */

  }, {
    key: "valueOfField",
    value: function valueOfField(input) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var level = arguments.length > 2 ? arguments[2] : undefined;
      level = level || ValidationLevel_1.ValidationLevel.Basic;
      var inp = null;

      if (input === null || input === undefined) {
        inp = input;
      } else {
        if (!utils_1.Utils.isObject(input)) {
          throw new DataDictionaryError_1.DataDictionaryError('Provided value is not an object: ' + JSON.stringify(input));
        }

        inp = input[key || this.simpleNameKey()];
      }

      return this.valueOf(inp, level);
    }
  }, {
    key: "mergeDescs",
    value: function mergeDescs(descr) {
      var ret = {};
      Object.assign(ret, this.description, descr);
      return ret;
    }
  }, {
    key: "simpleNameKey",
    value: function simpleNameKey() {
      if (!this._snk) {
        var i = this.description.nameKey.indexOf('_');
        this._snk = i < 0 ? this.description.nameKey : this.description.nameKey.substring(i + 1);
      }

      return this._snk;
    }
  }]);

  return ValueDesc;
}();

exports.ValueDesc = ValueDesc;